import React from 'react';
import PropTypes from 'prop-types';
import HexInput from 'common/components/hex-input';
import SwatchButton from 'common/components/swatch-button';
import SwatchPicker from 'common/components/swatch-picker';
import Colors from 'common/constants/colors';
import './index.scss';

export default class ColorPicker extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    colors: PropTypes.arrayOf(PropTypes.array),
    handleChange: PropTypes.func,
    position: PropTypes.string,
  };

  static defaultProps = {
    color: Colors.white,
    colors: undefined,
    handleChange: () => {},
    position: '',
  };

  constructor() {
    super();
    this.state = {
      isActive: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  render() {
    return (
      <div className={'ColorPicker'} ref={(node) => (this._node = node)}>
        <SwatchButton
          color={this.props.color}
          handleClick={this.handleClick}
          isActive={this.state.isActive}
        />
        {this.state.isActive ? (
          <div
            className={`
              ColorPicker--inputs
              ColorPicker--inputs--${this.props.position}
            `}>
            <SwatchPicker
              colors={this.props.colors}
              handleChange={this.handleChange}
            />
            <HexInput
              handleChange={this.handleChange}
              value={this.props.color}
            />
          </div>
        ) : null}
      </div>
    );
  }

  handleChange(color, shouldClose) {
    if (shouldClose) {
      this.setState({
        isActive: !this.state.isActive,
      });
    }
    this.props.handleChange(color);
  }

  handleClick() {
    this.setState({
      isActive: !this.state.isActive,
    });
  }

  handleDocumentClick(event) {
    if (!this._node.contains(event.target)) {
      this.setState({
        isActive: false,
      });
    }
  }
}
